import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8 flex flex-col gap-8 max-w-[1200px] mx-auto" }

import Footer from "@/components/identity/Footer.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Page',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})